import { useAppApi } from 'hooks/useAppApi';
import { createContext, useCallback, useContext } from 'react';

const ClientesContext = createContext(null);

export const ClientesProvider = ({ children, id }) => {
  const map = useCallback((result) => {
    return result;
  }, []);

  const {
    data,
    isLoading: loading,
    error,
    hasCalled,
    call,
  } = useAppApi({
    baseUrl: '/clientes',
    mapResults: map,
  });

  return (
    <ClientesContext.Provider
      value={{
        call,
        id,
        loading,
        error,
        hasCalled,
        data,
      }}
    >
      {children}
    </ClientesContext.Provider>
  );
};

export const useClientes = () => useContext(ClientesContext);
